import React, { useEffect, useRef } from "react";
import "../assets/styles/BentoGrid.css";

import gallery01 from "../assets/gallery/gallery-1.jpeg";
import gallery02 from "../assets/gallery/gallery-2.jpeg";
import gallery03 from "../assets/gallery/gallery-3.jpeg";
import gallery04 from "../assets/gallery/gallery-4.jpeg";
import gallery06 from "../assets/gallery/gallery-6.jpeg";
import gallery07 from "../assets/gallery/gallery-7.jpeg";
import gallery08 from "../assets/gallery/gallery-8.jpeg";
import gallery09 from "../assets/gallery/gallery-9.jpeg";
import gallery10 from "../assets/gallery/gallery-10.jpeg";
import gallery11 from "../assets/gallery/gallery-11.jpeg";
import gallery12 from "../assets/gallery/gallery-12.jpeg";
import gallery13 from "../assets/gallery/gallery-13.jpeg";
import gallery14 from "../assets/gallery/gallery-14.jpeg";
import gallery15 from "../assets/gallery/gallery-15.jpeg";
import gallery16 from "../assets/gallery/gallery-16.png";
import gallery18 from "../assets/gallery/gallery-18.jpeg";

const galleryImages = [
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery06,
  gallery07,
  gallery08,
  gallery09,
  gallery10,
  gallery11,
  gallery12,
  gallery13,
  gallery14,
  gallery15,
  gallery16,
  gallery18,
];

// ── Scroll-reveal ─────────────────────────────────────────────────────────────

function useScrollReveal(selector = ".masonry-item") {
  const ref = useRef(null);

  useEffect(() => {
    const section = ref.current;
    if (!section) return;

    const items = section.querySelectorAll(selector);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.06 },
    );

    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, [selector]);

  return ref;
}

// ── Component ─────────────────────────────────────────────────────────────────

function BentoGrid() {
  const sectionRef = useScrollReveal(".masonry-item");

  return (
    <section
      id="gallery"
      className="bento-section"
      ref={sectionRef}
      aria-labelledby="bento-heading"
    >
      <div className="container">
        {/* Header */}
        <div className="section-head">
          <h2 id="bento-heading" className="section-title">
            Thoughtfully Designed Spaces
          </h2>
          <p className="section-desc">
            Discover beautifully crafted areas created for relaxation,
            celebrations, and unforgettable moments.
          </p>
        </div>

        {/* Masonry Grid */}
        <div className="masonry-grid" role="list">
          {galleryImages.map((img, i) => (
            <figure
              key={i}
              className="masonry-item"
              style={{ "--item-index": i }}
              role="listitem"
            >
              <img src={img} alt={`Villa gallery ${i + 1}`} loading="lazy" />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BentoGrid;
